import comment from '@/api/comment'
import channel from '@/api/channel'
import course from '@/api/course'
import coupon from '@/api/coupon'
import exchange from '@/api/exchange'
import vote from '@/api/vote'
import activity from '@/api/activity'

export default {
  comment: comment,
  channel: channel,
  course: course,
  coupon: coupon,
  exchange: exchange,
  vote: vote,
  activity: activity
}
